/* eslint-disable camelcase */

export default {
  resortName: state => state.resort.Name,
  resortSluggedName: (state) => {
    if (state.resort && state.resort.Name) {
      return state.resort.Name.toLowerCase().split(' ').join('-');
    }
  },
  isWinterResort: (state) => {
    if (state.resort && state.resort.Name) {
      return state.resort.Name.toLowerCase().indexOf('summer') < 0;
    }
  },
  isSummerResort: (state) => {
    if (state.resort && state.resort.Name) {
      return state.resort.Name.toLowerCase().indexOf('summer') >= 0;
    }
  },
  currentActiveMountainArea: state => state.activeMountainArea,
  currentActiveWeatherZone: state => state.activeWeatherZone,
  reversedWeatherZones: (state) => {
    if (state.weatherZones.length > 0) {
      return state.weatherZones.reverse();
    }
  },
  activeMountainAreaTrails: (state) => {
    if (state.activeMountainArea) {
      return state.activeMountainArea.Trails;
    }
    return state.trails;
  },
  activeMountainAreaLifts: (state) => {
    if (state.activeMountainArea) {
      return state.activeMountainArea.Lifts;
    }
    return state.lifts;
  },
  trailDifficultyMappings: state => ({ ...state.defaultTrailDifficultyMappings, ...state.trailDifficultyMappings }),
  getActiveMountainAreaLifts: (state) => {
    if (state.activeMountainArea === 'all') {
      return state.trails;
    }
    return state.activeMountainArea.Lifts;
  },
  activeMountainSection: state => state.activeMountainSection,
  getMaps: state => state.maps,
  baseUrl: (state) => {
    let baseUrl = '//mtnpowder.com/';
    const host = window.location.host.split(':')[0];

    if (
      state.embedEnvironment === 'staging'
      || host.indexOf('staging') > -1
    ) {
      baseUrl = '//snowreporting-staging.herokuapp.com/';
    }

    if (state.resortSlug.match(/tremblant-fr|tremblant-summer-fr/)) baseUrl += 'fr-CA/';
    baseUrl += 'feed';

    return baseUrl;
  },
  filterIcons: state => state.filterIcons,
  mtnAreaToggles: state => state.mtnAreaToggles,
  customIcons: state => state.customIcons,
  allTrailsLength: state => (state.trails ? state.trails.length : []),
  allOpenTrails: state => (state.snow_report ? state.snow_report.TotalOpenTrails : []),
  allOpenNightTrailsLength: (state) => {
    if (state.trails) {
      return state.trails.filter(trail => trail.NightSkiing === 'Yes').length;
    }
    return 0;
  },
  textOptions: state => state.textOptions,
  webcams: state => state.webcams,
  webcamTitleField: state => state.webcamTitleField,
  webcamSettings: state => ({
    vertical: true,
    itemsToShow: state.itemsToShow,
    breakpoints: state.hooperBreakpoints,
  }),
  weatherPrimaryLayoutOption: state => state.weatherPrimaryLayoutOption,
  weatherSecondaryLayoutOptions: state => state.weatherSecondaryLayoutOptions,
  weatherRoundPrimaryValues: state => state.weatherRoundPrimaryValues,
  weatherRoundSecondaryValues: state => state.weatherRoundSecondaryValues,
  openStatuses: state => state.openStatuses,
  closedStatuses: state => state.closedStatuses,
  lastUpdate: state => state.resort.LastUpdate,
  formattedLastUpdate: (state) => {
    // Maybe use moment for this
    if (state.resort.LastUpdate) {
      const date = state.resort.LastUpdate;
      const values = date.split(/[^0-9]/);
      let year = parseInt(values[0], 10);
      const month = parseInt(values[1], 10) - 1; // Month is zero based, subtract 1
      const day = parseInt(values[2], 10);
      let hours = parseInt(values[3], 10);
      let minutes = parseInt(values[4], 10);
      let seconds = parseInt(values[5], 10);
      let formattedDate = new Date(year, month, day, hours, minutes, seconds);
      const amOrPm = formattedDate.getHours() > 12 ? 'PM' : 'AM';

      year = formattedDate.getFullYear();
      hours = formattedDate.getHours() > 12
        ? formattedDate.getHours() - 12
        : formattedDate.getHours();
      minutes = formattedDate.getMinutes();
      seconds = formattedDate.getSeconds();
      minutes = minutes < 10 ? `0${minutes}` : minutes;
      seconds = seconds < 10 ? `0${seconds}` : seconds;

      const replacement = `${hours}:${minutes}:${seconds}`;
      const pattern = new RegExp(`0?${formattedDate.getHours()}:${minutes}:${seconds}`);

      formattedDate = formattedDate.toString().replace(/GMT.*/g, '');
      const dateSplit = formattedDate.split(year);
      return dateSplit[0] + dateSplit[1].replace(pattern, replacement) + amOrPm;
    }
  },
};
